import { useEffect, useRef } from 'react'
import { useOutletContext } from 'react-router'
import { CurrentUser } from '../../../services/schema/User'

export default function CustomCreateReplyWrapper() {
  const elementRef = useRef<HTMLElement>(null)
  const user = useOutletContext<CurrentUser>()

  if (user) {
    const profilePic =
      user.profilePicture !== null ? user.profilePicture : '/user_sample.jpg'
    return (
      <div className="border-theme relative flex h-auto w-full max-w-[600px] border-b pt-[20px] pr-[25px] pl-[15px]">
        <div className="flex h-auto w-[50px] shrink-0 select-none">
          <div
            data-id="profile-picture"
            className="flex h-[40px] w-[40px] cursor-pointer items-center justify-center rounded-full bg-cover bg-center"
            style={{
              backgroundImage: `url(${profilePic})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          />
        </div>
        <custom-create-reply
          ref={elementRef}
          style={{ width: '100%' }}
        ></custom-create-reply>
      </div>
    )
  }
}
